export const helpPageStyles = (theme) => {
  return {
    mdHelpCard: {
      backgroundColor: theme.palette.common.white,
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      overflowY: "auto",
    },

    mdHelpTitle: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.palette.common.white,
      padding: "12px 49px 12px 49px",
      fontSize: "0.875rem",
      color: `${theme.palette.custom.gray}`,
    },

    mdHighlightText: {
      color: `${theme.palette.primary.main}`,
    },

    mdHelpText: {
      color: `${theme.palette.custom.black}`,
      fontSize: "1.5rem",
      fontWeight: "700",
      backgroundColor: `${theme.palette.custom.backgroundColor}`,
      padding: "32px 49px 32px 49px",
    },

    mdFreAsked: {
      padding: "12px 49px 12px 49px",
      fontSize: "1.375rem",
      fontWeight: "700",
      color: `${theme.palette.custom.black}`,
      gap: "32px",
      backgroundColor: theme.palette.common.white,
    },

    mdAccordionContainer: {
      boxShadow: "none",
      backgroundColor: `${theme.palette.custom.white}`,
      width: "58.125rem",
      "::before": {
        display: "none !important",
      },
    },

    mdAccordionSummary: {
      width: "58.125rem",
      margin: "12px 49px 12px 49px",
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },

    mdAccordionSummaryExpanded: {
      width: "58.125rem",
      margin: "12px 49px 12px 49px",
      backgroundColor: `${theme.palette.custom.gray}`,
      color: `${theme.palette.custom.white}`,
    },

    mdAccordionSummaryExpandedIcon: {
      fontSize: "45px",
      color: `${theme.palette.custom.white}`,
    },
    mdAccordionSummaryIcon: {
      fontSize: "45px",
      color: `${theme.palette.custom.gray}`,
    },

    mdAccordionContent: {
      width: "58.125rem",
      margin: "5px 0px 10px 80px",
    },

    mdAccordionContentHeading: {
      fontSize: "1.125rem",
      fontWeight: "700",
      color: `${theme.palette.custom.darkGray}`,
      marginBottom: "1rem;",
    },

    mdAccordionContentBody: {
      fontSize: "1.125rem",
      fontWeight: "500",
      color: `${theme.palette.custom.darkGray}`,
    },

    mdAccordionLine: {
      borderBottom: `${theme.palette.primary.light}`,
      width: "58.125rem",
      margin: "12px 49px 12px 49px",
    },

    mdContactText: {
      margin: "12px 49px 12px 49px",
      width: "90%",
      fontWeight: "600",
      fontSize: "1.25rem",
    },

    mdFaqCategory: {
      padding: "16px 49px 4px 49px",
      fontSize: "1.05rem",
      fontWeight: 700,
      color: `${theme.palette.primary.main}`,
    },

    mdSectionSubtitle: {
      padding: "0px 49px 8px 49px",
      fontSize: "1rem",
      color: `${theme.palette.custom.darkGray}`,
    },

    mdFormsRow: {
      display: "flex",
      flexWrap: "wrap",
      gap: "24px",
      padding: "8px 49px 48px 49px",
    },

    mdFormCard: {
      flex: "1 1 360px",
      minWidth: "300px",
      maxWidth: "520px",
      display: "flex",
      flexDirection: "column",
      backgroundColor: `${theme.palette.common.white}`,
      border: `1px solid ${theme.palette.custom.gray}`,
      borderRadius: "8px",
      padding: "20px",
    },

    mdFormTitle: {
      fontSize: "1.125rem",
      fontWeight: 700,
      color: `${theme.palette.custom.black}`,
      marginBottom: "4px",
    },

    mdFormSubtitle: {
      fontSize: "0.9rem",
      color: `${theme.palette.custom.darkGray}`,
      marginBottom: "16px",
    },

    mdFormField: {
      marginBottom: "16px",
    },

    mdFormButton: {
      alignSelf: "flex-start",
    },

    mdRatingRow: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      marginBottom: "16px",
    },

    mdRatingLabel: {
      fontSize: "0.9rem",
      color: `${theme.palette.custom.darkGray}`,
    },
  };
};
